module.exports = __webpack_public_path__ + "static/media/Severe_Flood_Warning_small.05a4362f.png";